// X renders the original posts and media. Static excerpts remain readable if
// JavaScript, the platform or an individual post is unavailable.
export function installEditorialEmbeds(root = document) {
  const posts = root.querySelectorAll('.twitter-tweet');
  if (!posts.length) return;
  let requested = false;
  const load = () => {
    if (requested) return;
    requested = true;
    const script = root.createElement('script');
    script.id = 'editorial-twitter-widgets';
    script.async = true;
    script.src = 'https://platform.twitter.com/widgets.js';
    root.head.append(script);
  };
  if (typeof IntersectionObserver !== 'function') { load(); return; }
  const observer = new IntersectionObserver(entries => {
    if (!entries.some(entry => entry.isIntersecting)) return;
    observer.disconnect();
    load();
  }, { rootMargin: '600px 0px' });
  posts.forEach(post => observer.observe(post));
}

installEditorialEmbeds();
